// import React, { useRef, useEffect, useState } from "react";
// import "./web.css";
// import pyconfig from "../config";
// import { useLocation,} from "react-router-dom";
// function Webrtc() {
//   const localVideoRef = useRef(null);
//   const idleVideoRef = useRef(null);
//   const talkVideoRef = useRef(null);
//   const connectBtnRef = useRef(null);
//   const destroyBtnRef = useRef(null);
//   const streamRef = useRef(null);
//   const audioChunksRef = useRef([]); 
//   const [inCall, setInCall] = useState(false);  
//   const [muted, setMuted] = useState(false);     
//   const [recording, setRecording] = useState(false);
//   const [peerConnection, setPeerConnection] = useState(null);
//   const streamIdRef = useRef(null);
//   const sessionIdRef = useRef(null);
//   const [statsIntervalId, setStatsIntervalId] = useState(null);
//   const [lastBytesReceived, setLastBytesReceived] = useState(0);
//   const { state } = useLocation();
//   const name = state?.name || "You";

//   const startInteraction = async () => {
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({
//         video: { width: { ideal: 640 }, height: { ideal: 480 } },
//         audio: true,
//       });
//       streamRef.current = stream;
//       if (localVideoRef.current) {
//         localVideoRef.current.srcObject = stream;
//         await localVideoRef.current.play();
//       }
//       setInCall(true);
//       setMuted(false);
//     } catch (err) {
//       console.error("Device access error:", err);
//       alert("Please allow camera & microphone permissions.");
//     }
//   };


//   // Mute/unmute mic
//   const toggleMute = () => {
//     const s = streamRef.current;
//     if (!s) return;
//     s.getAudioTracks().forEach((t) => (t.enabled = !t.enabled));
//     setMuted((m) => !m);
//   };

//   // Cleanup
//   const cleanup = () => {
//     try {
//       peerConnection?.close();
//     } catch {}
//     setPeerConnection(null);

//     if (statsIntervalId) {
//       clearInterval(statsIntervalId);
//       setStatsIntervalId(null);
//     }

//     if (talkVideoRef.current) {
//       talkVideoRef.current.pause();
//       talkVideoRef.current.srcObject = null;
//       talkVideoRef.current.style.display = "none";
//     }
//     if (idleVideoRef.current) {
//       idleVideoRef.current.style.display = "block";
//     }

//     setLastBytesReceived(0);
//   };

//   // Connect to backend stream
//   const handleConnect = async () => {
//     const btn = connectBtnRef.current;
//     const destroyBtn = destroyBtnRef.current;
//     btn.classList.add("loading");

//     try {
//       cleanup();

//       const startRes = await fetch(`${pyconfig.apiBaseUrl}/webrtc/start`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({}),
//       });
//       if (!startRes.ok) throw new Error(await startRes.text());
//       const data = await startRes.json();

//       const offer = data.offer;
//       const iceServers = data.ice_servers || [];
//       const sId = data.stream_id || data.id;
//       const sessId = data.session_id;

//      streamIdRef.current = sId;
//      sessionIdRef.current = sessId;


//       const pc = new RTCPeerConnection({ iceServers });
//       setPeerConnection(pc);

//       pc.ontrack = (event) => {
//         if (event.track.kind !== "video") return;
//         if (talkVideoRef.current) {
//           talkVideoRef.current.srcObject = event.streams[0];
//           talkVideoRef.current.play().catch(console.warn);
//           idleVideoRef.current.style.display = "none";
//           talkVideoRef.current.style.display = "block";
//         }
//       };

//       pc.onicecandidate = (e) => {
//         if (!e.candidate) return;
//         fetch(`${pyconfig.apiBaseUrl}/webrtc/ice/${sId}`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             session_id: sessId,
//             candidate: e.candidate.candidate,
//             sdpMid: e.candidate.sdpMid,
//             sdpMLineIndex: e.candidate.sdpMLineIndex,
//           }),
//         }).catch(console.warn);
//       };

//       await pc.setRemoteDescription(offer);
//       const answer = await pc.createAnswer();
//       await pc.setLocalDescription(answer);

//       const sdpRes = await fetch(`${pyconfig.apiBaseUrl}/webrtc/answer/${sId}`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ session_id: sessId, answer }),
//       });
//       if (!sdpRes.ok) throw new Error(await sdpRes.text());

//       btn.classList.remove("loading");
//       btn.classList.add("connected");
//       destroyBtn.disabled = false;
//     } catch (err) {
//       console.error(err);
//       alert(`Connection failed: ${err.message}`);
//       btn.classList.remove("loading", "connected");
//       cleanup();
//     }
//   };


// const setupVoiceDetection = () => {
//   const audioContext = new (window.AudioContext || window.webkitAudioContext)();
//   const micSource = audioContext.createMediaStreamSource(streamRef.current);
//   const analyser = audioContext.createAnalyser();
//   analyser.fftSize = 512;
//   micSource.connect(analyser);
//   const dataArray = new Uint8Array(analyser.frequencyBinCount);

//   let speaking = false;
//   let silenceTimer = null;
//   let recorder = null;

//   const startRecording = () => {
//     if (recording || !streamRef.current) return;
//     setRecording(true);
//     audioChunksRef.current = [];
//     const audioStream = new MediaStream(streamRef.current.getAudioTracks());
//     recorder = new MediaRecorder(audioStream);

//     recorder.ondataavailable = (e) => {
//       if (e.data.size > 0) audioChunksRef.current.push(e.data);
//     };

//     recorder.onstop = async () => {
//       const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });
//       const formData = new FormData();
//       formData.append("session_id",sessionIdRef.current);
//       formData.append("file", audioBlob, "recording.webm");

//       try {
//         const r = await fetch(`${pyconfig.apiBaseUrl}/webrtc/talk-audio/${streamIdRef.current}/male`, {
//           method: "POST",
//           body: formData,
//         });
//         if (!r.ok) throw new Error(await r.text());
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setRecording(false);
//       }
//     };

//     recorder.start();
//   };

//   const stopRecording = () => {
//     if (recorder && recorder.state !== "inactive") {
//       recorder.stop();
//     }
//   };

//   const detect = () => {
//     analyser.getByteFrequencyData(dataArray);
//     const volume = dataArray.reduce((a, b) => a + b) / dataArray.length;

//     if (volume > 8) {
//       if (!speaking) {
//         speaking = true;
//         startRecording();
//       }
//       clearTimeout(silenceTimer);
//       silenceTimer = setTimeout(() => {
//         speaking = false;
//         stopRecording();
//       }, 1000);
//     }

//     requestAnimationFrame(detect);
//   };

//   detect();
// };




// const handleDestroy = async () => {
//   try {
//     if (streamIdRef.current && sessionIdRef.current) {
//       await fetch(`${pyconfig.apiBaseUrl}/webrtc/stop/${streamIdRef.current}`, {
//         method: "DELETE",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ session_id: sessionIdRef.current}),
//       });
//     }
//   } catch (e) {
//     console.warn("stop failed", e);
//   } finally {
//     cleanup();
//     connectBtnRef.current.classList.remove("connected", "loading");
//     connectBtnRef.current.innerText = "Connect";
//     destroyBtnRef.current.disabled = true;
//   }
// };


// useEffect(() => {
//   (async () => {
//     await startInteraction();
//           setupVoiceDetection();    
//   })();
//   return () => cleanup();
// }, []);


//   return (
//     <div className="h-100">
//     <div className="call-stage">
//       <div className="h-100">
//       <div className="videos-wrap">
//         <div className="pane pane-avatar">
//           <video className="video-el" ref={idleVideoRef} src="./idle.mp4" autoPlay muted loop playsInline></video>
//           <video className="video-el" ref={talkVideoRef} autoPlay playsInline />
//           <div className="label">AI Avatar</div>
//         </div>
  

//       <div className="pane pane-you">
//         <video ref={localVideoRef} className="video-el" playsInline muted />
//         <div className="label">{name || "you"}</div>

//         {inCall && (
//           <div className="mini-controls">
//             <button className={`chip ${muted ? "chip-off" : ""}`} onClick={toggleMute}>
//               {muted ? "Unmute" : "Mute"}
//             </button>
//            {recording && (
//               <div className="voice-indicator">
//                 <i className="fas fa-microphone-lines fa-beat-fade"></i>
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </div>


//       <div className="connect-buttons">
//         <button className="btn-connect" ref={connectBtnRef} type="button" onClick={handleConnect}>
//           Connect
//         </button>
//         <button className="btn-disconnect " ref={destroyBtnRef} type="button"  onClick={handleDestroy}>
//           Disconnect
//         </button>
//       </div>
//     </div>
//     </div>
//     </div>
//   );
// }

// export default Webrtc;


import React, { useRef, useEffect, useState } from "react";
import "./web.css";
import pyconfig from "../config";
import { useLocation } from "react-router-dom";

function Webrtc() {
  const localVideoRef = useRef(null);
  const idleVideoRef = useRef(null);
  const talkVideoRef = useRef(null);
  const connectBtnRef = useRef(null);
  const destroyBtnRef = useRef(null);
  const streamRef = useRef(null);
  const audioChunksRef = useRef([]);
  const [inCall, setInCall] = useState(false);
  const [muted, setMuted] = useState(false);
  const [recording, setRecording] = useState(false);
  const [peerConnection, setPeerConnection] = useState(null);
  const streamIdRef = useRef(null);
  const sessionIdRef = useRef(null);
  const [statsIntervalId, setStatsIntervalId] = useState(null);
  const [lastBytesReceived, setLastBytesReceived] = useState(0);
  const { state } = useLocation();
  const name = state?.name || "You";

  const startInteraction = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { width: { ideal: 640 }, height: { ideal: 480 } },
        audio: true,
      });
      streamRef.current = stream;
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = stream;
        await localVideoRef.current.play();
      }
      setInCall(true);
      setMuted(false);
    } catch (err) {
      console.error("Device access error:", err);
      alert("Please allow camera & microphone permissions.");
    }
  };

  const toggleMute = () => {
    const s = streamRef.current;
    if (!s) return;
    s.getAudioTracks().forEach((t) => (t.enabled = !t.enabled));
    setMuted((m) => !m);
  };

  const cleanup = () => {
    try {
      peerConnection?.close();
    } catch {}
    setPeerConnection(null);

    if (statsIntervalId) {
      clearInterval(statsIntervalId);
      setStatsIntervalId(null);
    }

    if (talkVideoRef.current) {
      talkVideoRef.current.pause();
      talkVideoRef.current.srcObject = null;
      talkVideoRef.current.style.display = "none";
    }
    if (idleVideoRef.current) {
      idleVideoRef.current.style.display = "block";
    }

    setLastBytesReceived(0);
  };

  const setupVoiceDetection = () => {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const micSource = audioContext.createMediaStreamSource(streamRef.current);
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 512;
    micSource.connect(analyser);
    const dataArray = new Uint8Array(analyser.frequencyBinCount);

    let speaking = false;
    let silenceTimer = null;
    let recorder = null;

    const startRecording = () => {
      if (recording || !streamRef.current) return;
      setRecording(true);
      audioChunksRef.current = [];
      const audioStream = new MediaStream(streamRef.current.getAudioTracks());
      recorder = new MediaRecorder(audioStream);

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data);
      };

      recorder.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });
        const formData = new FormData();
        formData.append("session_id", sessionIdRef.current);
        formData.append("file", audioBlob, "recording.webm");

        try {
          const r = await fetch(`${pyconfig.apiBaseUrl}/webrtc/talk-audio/${streamIdRef.current}/male`, {
            method: "POST",
            body: formData,
          });
          if (!r.ok) throw new Error(await r.text());
        } catch (e) {
          console.error(e);
        } finally {
          setRecording(false);
        }
      };

      recorder.start();
    };

    const stopRecording = () => {
      if (recorder && recorder.state !== "inactive") {
        recorder.stop();
      }
    };

    const detect = () => {
      analyser.getByteFrequencyData(dataArray);
      const volume = dataArray.reduce((a, b) => a + b) / dataArray.length;
console.log('Current volume:', volume);
      if (volume > 3) {
        if (!speaking) {
          speaking = true;
          startRecording();
        }
        clearTimeout(silenceTimer);
        silenceTimer = setTimeout(() => {
          speaking = false;
          stopRecording();
        }, 1000);
      }

      requestAnimationFrame(detect);
    };

    detect();
  };

  const handleConnect = async () => {
    const btn = connectBtnRef.current;
    const destroyBtn = destroyBtnRef.current;
    btn.classList.add("loading");

    try {
      cleanup();

      const startRes = await fetch(`${pyconfig.apiBaseUrl}/webrtc/start`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      if (!startRes.ok) throw new Error(await startRes.text());
      const data = await startRes.json();

      const offer = data.offer;
      const iceServers = data.ice_servers || [];
      const sId = data.stream_id || data.id;
      const sessId = data.session_id;

      streamIdRef.current = sId;
      sessionIdRef.current = sessId;

      const pc = new RTCPeerConnection({ iceServers });
      setPeerConnection(pc);

      pc.ontrack = (event) => {
        if (event.track.kind !== "video") return;
        if (talkVideoRef.current) {
          talkVideoRef.current.srcObject = event.streams[0];
          talkVideoRef.current.play().catch(console.warn);
          idleVideoRef.current.style.display = "none";
          talkVideoRef.current.style.display = "block";
        }
      };

      pc.onicecandidate = (e) => {
        if (!e.candidate) return;
        fetch(`${pyconfig.apiBaseUrl}/webrtc/ice/${sId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            session_id: sessId,
            candidate: e.candidate.candidate,
            sdpMid: e.candidate.sdpMid,
            sdpMLineIndex: e.candidate.sdpMLineIndex,
          }),
        }).catch(console.warn);
      };

      await pc.setRemoteDescription(offer);
      const answer = await pc.createAnswer();
      await pc.setLocalDescription(answer);

      const sdpRes = await fetch(`${pyconfig.apiBaseUrl}/webrtc/answer/${sId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessId, answer }),
      });
      if (!sdpRes.ok) throw new Error(await sdpRes.text());

      btn.classList.remove("loading");
      btn.classList.add("connected");
      destroyBtn.disabled = false;

      // Start voice detection after successful connection
      setupVoiceDetection();
    } catch (err) {
      console.error(err);
      alert(`Connection failed: ${err.message}`);
      btn.classList.remove("loading", "connected");
      cleanup();
    }
  };

  const handleDestroy = async () => {
    try {
      if (streamIdRef.current && sessionIdRef.current) {
        await fetch(`${pyconfig.apiBaseUrl}/webrtc/stop/${streamIdRef.current}`, {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionIdRef.current }),
        });
      }
    } catch (e) {
      console.warn("stop failed", e);
    } finally {
      cleanup();
      connectBtnRef.current.classList.remove("connected", "loading");
      connectBtnRef.current.innerText = "Connect";
      destroyBtnRef.current.disabled = true;
    }
  };

  useEffect(() => {
    (async () => {
      await startInteraction();
    })();
    return () => cleanup();
  }, []);

  return (
    <div className="h-100">
      <div className="call-stage">
        <div className="h-100">
          <div className="videos-wrap">
            <div className="pane pane-avatar">
              <video
                className="video-el"
                ref={idleVideoRef}
                src="./idle.mp4"
                autoPlay
                muted
                loop
                playsInline
              ></video>
              <video className="video-el" ref={talkVideoRef} autoPlay playsInline />
              <div className="label">AI Avatar</div>
            </div>

            <div className="pane pane-you">
              <video ref={localVideoRef} className="video-el" playsInline muted />
              <div className="label">{name || "you"}</div>

              {inCall && (
                <div className="mini-controls">
                  <button className={`chip ${muted ? "chip-off" : ""}`} onClick={toggleMute}>
                    {muted ? "Unmute" : "Mute"}
                  </button>
                  {recording && (
                    <div className="voice-indicator">
                      <i className="fas fa-microphone-lines fa-beat-fade"></i>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="connect-buttons">
            <button className="btn-connect" ref={connectBtnRef} type="button" onClick={handleConnect}>
              Connect
            </button>
            <button
              className="btn-disconnect"
              ref={destroyBtnRef}
              type="button"
              onClick={handleDestroy}
            >
              Disconnect
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Webrtc;